import { render } from "./SerialNumber.vue?vue&type=template&id=440a1a66"
import script from "./SerialNumber.vue?vue&type=script&lang=js"
export * from "./SerialNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__